import { MantineTheme, luminance } from '@mantine/core';

import { useGlobalTheme } from './useGlobalTheme';

export function useGetContrastColor(color: string) {
  const theme = useGlobalTheme();
  return getContrastColor(theme, color);
}

export function getContrastColor(theme: MantineTheme, color: string) {
  const colorLuminance = luminance(color);
  return colorLuminance > 0.5 ? theme.other.colors.neutral.black : theme.other.colors.neutral.white;
}
